import type { RewardTypeSlug } from '@/types/types'

export const REWARD_TYPE_FAMILIES = {
  discount: [
    'voucher_discount_percent',
    'voucher_discount_amount',
    'product_discount_percent',
    'product_discount_amount'
  ],
  percentDiscount: ['voucher_discount_percent', 'product_discount_percent'],
  productScopedDiscount: ['product_discount_percent', 'product_discount_amount'],
  xForY: ['voucher_x_for_y'],
  freeProduct: ['free_product'],
  freeDelivery: ['voucher_free_delivery'],
  merchantProductSku: ['free_product', 'product_discount_amount', 'product_discount_percent']
} as const satisfies Record<string, RewardTypeSlug[]>

export type RewardFamily = keyof typeof REWARD_TYPE_FAMILIES

export function slugBelongsTo(family: RewardFamily, slug: string | undefined): boolean {
  if (!slug) return false
  return (REWARD_TYPE_FAMILIES[family] as readonly string[]).includes(slug)
}
